// TODO: Swimlane docs
import { AbstractControl, FormArray, FormControl } from '@angular/forms'

import {
  AccessManagementAttributes,
  AccessManagementRole,
  UserGroup,
  UserWorkspaceAssignments,
} from '@flowx/designer/modules/core/dictionary/access-management.dictionary'

export interface UserFormAttribute {
  key: string
  values: string[]
}

export interface UserForm<T, U> {
  id: FormControl<string | null>
  email: FormControl<string | null>
  firstName: FormControl<string | null>
  lastName: FormControl<string | null>
  enabled: FormControl<boolean | null>
  password: FormControl<string | null>
  confirmPassword: FormControl<string | null>
  roles: FormControl<{ value: T; label: string; enabled: boolean }[] | null>
  groups: FormControl<{ value: U; label: string; enabled: boolean }[] | null>
  attributes: FormArray<AbstractControl<UserFormAttribute | null>>
  orgRoleId: FormControl<string | null>
  workspaceAssignments: FormControl<UserWorkspaceAssignments[] | null>
}

export interface UserFormValue {
  username: string
  email: string
  enabled: boolean
  firstName: string
  lastName: string
  password: string
  attributes: AccessManagementAttributes
  id?: string
  roles?: AccessManagementRole[]
  groups?: UserGroup[]
  orgRoleId?: string | null

  workspaceAssignments?: UserWorkspaceAssignments[]
}

export function formAttributesFromApiAttributes(
  userAttributes: Record<string, string[]>
): { key: string; values: string[] }[] {
  return Object.keys(userAttributes).map((key) => ({
    key,
    values: userAttributes[key],
  }))
}

// TODO: Swimlane docs
export function formAttributesToApiAttributes(
  formAttributes: UserFormAttribute[]
): AccessManagementAttributes {
  return formAttributes.reduce(
    (acc, attribute) => ({
      ...acc,
      [attribute.key]: attribute.values,
    }),
    {}
  )
}
